module.exports = __webpack_public_path__ + "static/media/knot-station.41f70836.png";